export const messagesEl = {
  server: {
    exception: {
      badcredentials: "Παρακαλώ χρησιμοποιήστε σωστό συνδιασμό ονόματος χρήστη και κωδικού!",
      accessdenied: "Δεν επιτρέπεται η πρόσβαση στην συγκεκριμένη υπηρεσία!",
      unknown: "Αγνωστο πρόβλημα. Παρακαλώ δοκιμάστε αργότερα!"
    }
  }
}
